<div class="donut-draggable" ref="view"><slot></slot></div>